// eslint-disable-next-line import/prefer-default-export
export const pageTypes = {
  informational: {
    section: 'navigation',
    showLogoWithLink: true,
    disableSearch: false,
    customComponent: false,
    exclusiveOperator: false,
    navMenu: 'main_menu',
    showNavMenu: true,
    disablePopup: true,
  },
  responsible_gambling_guide: {
    section: 'rg_navigation',
    showLogoWithLink: false,
    disableSearch: false,
    customComponent: false,
    exclusiveOperator: false,
    navMenu: 'rg_menu',
    showNavMenu: true,
    disablePopup: true,
  },
  author: {
    section: 'navigation',
    showLogoWithLink: true,
    disableSearch: false,
    customComponent: true,
    exclusiveOperator: true,
    navMenu: 'main_menu',
    showNavMenu: true,
    disablePopup: true,
  },
  ppc: {
    showNavMenu: false,
    showLogoWithLink: false,
    disablePopup: true,
  },
  sports: {
    disablePopup: true,
  },
  default: {
    section: 'navigation',
    showLogoWithLink: true,
    disableSearch: false,
    customComponent: false,
    exclusiveOperator: true,
    navMenu: 'main_menu',
    showNavMenu: true,
    disablePopup: false,
    showNotification: true,
  },
};
